import { render, staticRenderFns } from "./SingleList.vue?vue&type=template&id=dfbf95e4&scoped=true&"
import script from "./SingleList.vue?vue&type=script&lang=js&"
export * from "./SingleList.vue?vue&type=script&lang=js&"
import style0 from "./SingleList.vue?vue&type=style&index=0&id=dfbf95e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbf95e4",
  null
  
)

export default component.exports